import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-79a34bd2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "step-warp cms-card-block"
};
const _hoisted_3 = {
  class: "row-warp"
};
const _hoisted_4 = {
  class: "header"
};
const _hoisted_5 = {
  class: "cms-module-title"
};
const _hoisted_6 = {
  class: "table-form"
};
const _hoisted_7 = {
  class: "cms-data-info-table",
  cellspacing: "0",
  cellpadding: "0"
};
const _hoisted_8 = ["width"];
const _hoisted_9 = {
  class: "cms-data-info-table",
  cellspacing: "0",
  cellpadding: "0"
};
const _hoisted_10 = ["width"];
const _hoisted_11 = {
  key: 0,
  class: "row-warp"
};
const _hoisted_12 = {
  class: "cms-module-title mg-t--25 mg-b--25"
};
const _hoisted_13 = {
  key: 1,
  class: "row-warp"
};
const _hoisted_14 = {
  class: "header"
};
const _hoisted_15 = {
  class: "cms-module-title"
};
const _hoisted_16 = {
  class: "picture-form"
};
const _hoisted_17 = {
  class: "cover-image-list"
};
const _hoisted_18 = {
  class: "background-image-list"
};
const _hoisted_19 = {
  key: 2,
  class: "row-warp"
};
const _hoisted_20 = {
  class: "header"
};
const _hoisted_21 = {
  class: "cms-module-title"
};
const _hoisted_22 = {
  class: "picture-form"
};
const _hoisted_23 = {
  class: "cover-image-list"
};
const _hoisted_24 = {
  class: "background-image-list"
};
const _hoisted_25 = {
  class: "result"
};
const _hoisted_26 = {
  class: "blod"
};
const _hoisted_27 = {
  key: 0
};
const _hoisted_28 = {
  style: {
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_29 = ["src", "alt"];
import ActionHeader from '@/views/common/ActionHeader/index.vue';
import BaseFormItem from '../AddOrEdit/components/FirstStep/BaseFormItem.vue';
import ImageItem from '../../Components/ImageItem/index.vue';
import { useI18n } from 'vue-i18n';
import { useVodLanguages } from '@/utils/cacheData';
import { provide } from 'vue';
import { useCommon } from '@/store/useCommon';
import { RELEASE_STATUS_NEW } from '@/assets/config/dicts';
import { getSeriesInfoApi, getAgentRelationCategorysApi, getCloudDiskOptionsApi } from '@/api/vodNew';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    detailInfo: {
      type: Object,
      default: () => {}
    },
    showResult: {
      type: Boolean,
      default: true
    },
    cid: {
      type: [String, Number],
      default: undefined
    }
  },
  emits: ['update:modelValue', 'update-list'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const FormRef = ref(null);
    const cloudDiskOptions = ref(); // 标题配置

    const headerConfig = reactive({
      title: '查看',
      btnList: [{
        label: '返回',
        func: () => {
          back();
        }
      }]
    }); // 获取回显信息

    const getProgramSetById = async () => {
      data.infoLoading = true;

      try {
        const {
          id
        } = props.detailInfo;
        const res = await getSeriesInfoApi({
          videoSeriesId: id
        });

        if (res.code == '0') {
          formConfig.formData = res.data.texts.map(item => {
            return { ...item
            };
          });
          formConfig.otherData.cloudDiskAccountIdList = res.data.cloudDiskAccountIdList;
          data.releaseStatus = res.data.releaseStatus;
          data.offlineReason = res.data.offlineReason;
          getCoverOrBgList(res.data.posters);

          if (res.data.categoryIdList && res.data.categoryIdList.length > 0 && useCommon().userData.permissionKey.indexOf('DC_AT') > -1) {
            getSubCategoryName(res.data.categoryIdList);
          }
        }
      } catch (error) {}

      data.infoLoading = false;
    }; // 获取回显上传图片


    const getCoverOrBgList = list => {
      if (list && list.length > 0) {
        list.forEach(item => {
          if (item.visualType === 'cover') {
            // 封面图
            data.coverList.push({ ...item,
              url: item.imageUrl
            });
          } else if (item.visualType === 'background') {
            // 背景图
            data.backgroundList.push({ ...item,
              url: item.imageUrl
            });
          }
        });
      }
    };

    const getCloudDiskOptions = async () => {
      const {
        code,
        data
      } = await getCloudDiskOptionsApi({
        name: useCommon().userData.name
      });

      if (code == 0) {
        cloudDiskOptions.value = data ? [...data] : [];
      }
    }; // 获取关联分类列表


    const getSubCategoryName = async categoryIds => {
      try {
        const cid = props.cid ?? sessionStorage.getItem('currentCid');
        let params = {
          categoryIds,
          cid // type: '4'

        }; //const res = await getAgentRelationCategoryApi(params) as ResType;

        const res = await getAgentRelationCategorysApi({
          categoryIdList: categoryIds,
          cid
        });

        if (res.code == '0') {
          tableConfig.data = res.data;
          console.log('tableConfig.data', tableConfig.data);
        }
      } catch (error) {}
    };

    const languageOptions = ref([]); // 获取所有语言

    const getAllLanguages = async () => {
      const res = await useVodLanguages();
      languageOptions.value = res;
    };

    provide('languageOptions', languageOptions);
    const formConfig = reactive({
      formList: [[{
        label: '系列片名称语言',
        prop: 'language',
        widgetType: 'text',
        required: true,
        placeholder: '请选择语言',
        filterable: true,
        list: languageOptions,
        controller: (value, data, config) => {
          return true;
        }
      }, {
        label: '系列名称',
        prop: 'name',
        widgetType: 'text',
        required: true,
        placeholder: '请输入系列名称',
        showDelete: true,
        rules: [{
          required: true,
          message: t('请输入系列名称'),
          trigger: 'blur'
        }]
      }]],
      otherFormList: [[{
        label: '关联网盘',
        prop: 'cloudDiskAccountIdList',
        widgetType: 'text',
        formatter: val => {
          if (!cloudDiskOptions.value) return '';
          let arr = [];
          cloudDiskOptions.value.forEach(item => {
            if (val.includes(item.id)) {
              arr.push(item.username);
            }
          });
          return arr ? arr.join() : '';
        }
      }, {
        label: '归属模式',
        prop: 'childMode',
        widgetType: 'text',
        formatter: val => {
          return val == 1 ? t('儿童模式') : t('常规模式');
        }
      }]],
      formData: [{
        language: '',
        name: ''
      }],
      otherData: {
        cloudDiskAccountIdList: []
      }
    });
    const data = reactive({
      imgVisible: false,
      dialogImageUrl: '',
      coverList: [],
      backgroundList: [],
      currentImgIndex: -1,
      operationList: [{
        src: require('@/assets/imgs/pic_search.png'),
        action: (item, index) => {
          data.imgVisible = true;
          data.dialogImageUrl = item.url ? item.url : item.file && item.file[0] ? item.file[0] : '';
        }
      }],
      uploadType: 3,
      infoLoading: false,
      releaseStatus: '',
      offlineReason: ''
    });
    watch(() => props.modelValue, val => {
      if (val) {
        getCloudDiskOptions();
        getAllLanguages();
        getProgramSetById();
      } else {
        formConfig.formData = [{
          language: '',
          name: ''
        }];
        data.coverList = [];
        data.backgroundList = [];
      }
    }, {
      immediate: true,
      deep: true
    });
    const tableConfig = reactive({
      data: [],
      isCardBlock: false,
      isShowHeader: false
    });
    const columnConfig = reactive({
      columnList: [{
        label: '主品牌名称',
        prop: 'mainAgentName',
        align: 'left'
      }, {
        label: '子品牌名称',
        prop: 'subAgentName',
        align: 'left'
      }, {
        label: '分类名称',
        prop: 'categoryName',
        align: 'left'
      }]
    }); // 返回

    const back = () => {
      emit('update:modelValue', false);
      emit('update-list');
    };

    return (_ctx, _cache) => {
      const _component_el_form = _resolveComponent("el-form");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [__props.modelValue ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(ActionHeader, {
        config: headerConfig
      }, null, 8, ["config"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('基础信息')), 1)]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_form, {
        model: formConfig.formData,
        ref_key: "FormRef",
        ref: FormRef,
        class: "search-form"
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("table", _hoisted_7, [_createElementVNode("colgroup", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(['25%', '25%', '25%', '20%'], c => {
          return _createElementVNode("col", {
            width: c
          }, null, 8, _hoisted_8);
        }), 64))]), _createElementVNode("tbody", null, [_createVNode(BaseFormItem, {
          "form-item": formConfig.otherFormList[0] || [],
          "form-data": formConfig.otherData,
          c_index: _ctx.index
        }, null, 8, ["form-item", "form-data", "c_index"])])])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formConfig.formData, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index
          }, [_createElementVNode("table", _hoisted_9, [_createElementVNode("colgroup", null, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(['25%', '25%', '25%', '20%'], c => {
            return _createElementVNode("col", {
              width: c
            }, null, 8, _hoisted_10);
          }), 64))]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formConfig.formList || [], (formItem, formIndex) => {
            return _openBlock(), _createBlock(BaseFormItem, {
              key: formIndex,
              "show-delete": false,
              "form-item": formItem,
              "form-data": formConfig.formData[index],
              c_index: index
            }, null, 8, ["form-item", "form-data", "c_index"]);
          }), 128))])])]);
        }), 128))]),
        _: 1
      }, 8, ["model"])])]), _unref(useCommon)().userData.permissionKey.indexOf('DC_AT') > -1 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('关联分类')), 1), _createVNode(_component_common_table, {
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        showPagination: false
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, null, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config"])])) : _createCommentVNode("", true), data.coverList.filter(f => f.posterType == 'common').length ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('通用海报')), 1)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(ImageItem, {
        "image-size": "224*168px",
        "image-style": "width:224px;height:168px",
        "img-list": data.coverList.filter(f => f.posterType == 'common'),
        "operation-list": data.operationList
      }, null, 8, ["img-list", "operation-list"])]), _createElementVNode("div", _hoisted_18, [_createVNode(ImageItem, {
        "image-title": "系列背景图",
        "image-size": "1920*1080px",
        "image-style": "width:299px;height:168px",
        "img-list": data.backgroundList.filter(f => f.posterType == 'common'),
        "operation-list": data.operationList
      }, null, 8, ["img-list", "operation-list"])])])])) : _createCommentVNode("", true), data.coverList.filter(f => f.posterType == 'android').length ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('安卓海报')), 1)]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createVNode(ImageItem, {
        "image-size": "224*168px",
        "image-style": "width:224px;height:168px",
        "img-list": data.coverList.filter(f => f.posterType == 'android'),
        "operation-list": data.operationList
      }, null, 8, ["img-list", "operation-list"])]), _createElementVNode("div", _hoisted_24, [_createVNode(ImageItem, {
        "image-title": "系列背景图",
        "image-size": "1920*1080px",
        "image-style": "width:299px;height:168px",
        "img-list": data.backgroundList.filter(f => f.posterType == 'android'),
        "operation-list": data.operationList
      }, null, 8, ["img-list", "operation-list"])])])])) : _createCommentVNode("", true)]), data.releaseStatus !== -1 && data.releaseStatus !== null && data.releaseStatus !== undefined ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "check-result",
        style: _normalizeStyle('background-color:' + (data.releaseStatus === 'online' || data.releaseStatus === 'not_online' ? '#f5faf8' : ''))
      }, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('上线状态')) + ":", 1), _createElementVNode("span", {
        class: "error-text",
        style: _normalizeStyle('color:' + (data.releaseStatus === 'online' || data.releaseStatus === 'not_online' ? '#3aaf81' : ''))
      }, _toDisplayString(_unref(RELEASE_STATUS_NEW)[data.releaseStatus]), 5)]), data.releaseStatus === 'offline' && data.offlineReason !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('原因')) + ":", 1), _createElementVNode("span", null, _toDisplayString(data.offlineReason), 1)])) : _createCommentVNode("", true)])], 4)) : _createCommentVNode("", true)])), [[_directive_loading, data.infoLoading]]) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        modelValue: data.imgVisible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.imgVisible = $event),
        closeOnClickModal: false,
        title: _ctx.$t('预览')
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", null, [_createElementVNode("img", {
          style: {
            "width": "100%",
            "height": "100%"
          },
          src: data.dialogImageUrl,
          alt: _ctx.$t('Preview Image')
        }, null, 8, _hoisted_29)])])]),
        _: 1
      }, 8, ["modelValue", "title"])], 64);
    };
  }

});